/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./row-skeleton.vue?vue&type=template&id=1f748c6f&"
import script from "./row-skeleton.vue?vue&type=script&lang=ts&"
export * from "./row-skeleton.vue?vue&type=script&lang=ts&"
import style0 from "./row-skeleton.vue?vue&type=style&index=0&id=1f748c6f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports